'use strict'

import {calculateUpgradePrice} from 'yougile-model'

export class CalcController {
  static init(): void {
    const newUsers: HTMLInputElement = document.querySelector('.new-users')
    const daysLeft: HTMLInputElement = document.querySelector('.days-left')

    const calculateAndUpdate = (): void => {
      const resp = calculateUpgradePrice(
        parseInt(newUsers.value),
        parseInt(daysLeft.value)
      )

      const formatter = new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB'
      })

      const cost = document.querySelector<HTMLSpanElement>('.cost')
      cost.innerHTML = formatter.format(resp)
    }

    const clearInputOnFocus = (input: HTMLInputElement): void => {
      input.addEventListener('focus', () => {
        input.value = ''
      })
    }

    if (newUsers) {
      newUsers.addEventListener('input', calculateAndUpdate)
      clearInputOnFocus(newUsers)
    }
    if (daysLeft) {
      daysLeft.addEventListener('input', calculateAndUpdate)
      clearInputOnFocus(daysLeft)
    }
  }
}
